import cloudinary from "cloudinary-core";

const cl = new cloudinary.Cloudinary({
  cloud_name: "haymarket-pri",
  api_key: "961798978258628",
  api_secret: "hkaw1wxCsGWoALtW2BRvsfwWw5w",
  invalidate: true,
});

const animationsData = {
  1: {
    desktop: [
      {
        direction: 'animated',
        duration: 1.2,
        delay: 0,
        src: cl.url('kesimpta_ate/8/0.svg'),
        type: 'mask',
        maskDirection: 'fromLeft'
      },
      {
        direction: 'animated',
        duration: 1.2,
        delay: 1,
        src: cl.url('kesimpta_ate/8/1.svg'),
        type: 'mask',
        maskDirection: 'fromLeft'
      },
      {
        direction: 'animated',
        duration: 1.2,
        delay: 2,
        src: cl.url('kesimpta_ate/8/2.svg'),
        type: 'fade',
      },
    ],
    mobile: [
      {
        direction: 'animated',
        duration: 1.2,
        delay: 0,
        src: cl.url('kesimpta_ate/8_mob/8_mob.svg'),
        type: 'mask',
        maskDirection: 'fromLeft'
      },
    ]
  },
  2: {
    desktop: [
      {
        direction: 'animated',
        duration: 1.2,
        delay: 0,
        src: cl.url('kesimpta_ate/7/0.svg'),
        type: 'mask',
        maskDirection: 'fromLeft'
      },
      {
        direction: 'animated',
        duration: 1.2,
        delay: 1,
        src: cl.url('kesimpta_ate/7/1.svg'),
        type: 'mask',
        maskDirection: 'fromLeft'
      },
      {
        direction: 'animated',
        duration: 1.2,
        delay: 1.5,
        src: cl.url('kesimpta_ate/7/2.svg'),
        type: 'mask',
        maskDirection: 'fromLeft'
      },
    ],
    mobile: [
      {
        direction: 'animated',
        duration: 1.2,
        delay: 0,
        src: cl.url('kesimpta_ate/7_mob/7_mob.svg'),
        type: 'mask',
        maskDirection: 'fromLeft'
      },
    ]
  },
  3: {
    desktop: [
      {
        direction: 'animated',
        duration: 1.2,
        delay: 0,
        src: cl.url('kesimpta_ate/5/0.svg'),
        type: 'mask',
        maskDirection: 'fromLeft'
      },
      {
        direction: 'animated',
        duration: 1.2,
        delay: 1,
        src: cl.url('kesimpta_ate/5/1.svg'),
        type: 'mask',
        maskDirection: 'fromTop'
      },
      {
        direction: 'animated',
        duration: 1.2,
        delay: 2,
        src: cl.url('kesimpta_ate/5/2.svg'),
        maskDirection: 'fade'
      },
    ],
    mobile: [
      {
        direction: 'animated',
        duration: 1.2,
        delay: 0,
        src: cl.url('kesimpta_ate/5_mob/5_mob.svg'),
        type: 'mask',
        maskDirection: 'fromLeft'
      },
    ]
  },
  4: {
    desktop: [
      {
        direction: 'animated',
        duration: 1.2,
        delay: 0,
        src: cl.url('kesimpta_ate/6/0.svg'),
        type: 'mask',
        maskDirection: 'fromLeft'
      },
      {
        direction: 'animated',
        duration: 1.2,
        delay: 1,
        src: cl.url('kesimpta_ate/6/1.svg'),
        type: 'mask',
        maskDirection: 'fromTop'
      },
      {
        direction: 'animated',
        duration: 1.2,
        delay: 2,
        src: cl.url('kesimpta_ate/6/2.svg'),
        type: 'fade',
      },
    ],
    mobile: [
      {
        direction: 'animated',
        duration: 1.2,
        delay: 0,
        src: cl.url('kesimpta_ate/6_mob/6_mob.svg'),
        type: 'mask',
        maskDirection: 'fromLeft'
      },
    ]
  },
  5: {
    desktop: [
      {
        direction: 'animated',
        duration: 1.2,
        delay: 0,
        src: cl.url('kesimpta_ate/4/0.svg'),
        type: 'mask',
        maskDirection: 'fromLeft'
      },
      {
        direction: 'animated',
        duration: 1.2,
        delay: 1,
        src: cl.url('kesimpta_ate/4/1.svg'),
        type: 'mask',
        maskDirection: 'fromTop'
      },
      {
        direction: 'animated',
        duration: 1.2,
        delay: 2,
        src: cl.url('kesimpta_ate/4/2.svg'),
        type: 'fade',
      },
    ],
    mobile: [
      {
        direction: 'animated',
        duration: 1.2,
        delay: 0,
        src: cl.url('kesimpta_ate/4_mob/4_mob.svg'),
        type: 'mask',
        maskDirection: 'fromLeft'
      },
    ]
  },
  6: {
    desktop: [
      {
        direction: 'animated',
        duration: 1.2,
        delay: 0,
        src: cl.url('kesimpta_ate/3/0.svg'),
        type: 'mask',
        maskDirection: 'fromLeft'
      },
      {
        direction: 'animated',
        duration: 1.2,
        delay: 1,
        src: cl.url('kesimpta_ate/3/1.svg'),
        type: 'mask',
        maskDirection: 'fromLeft'
      },
      {
        direction: 'animated',
        duration: 1.2,
        delay: 2,
        src: cl.url('kesimpta_ate/3/2.svg'),
        type: 'fade',
      },
      {
        direction: 'animated',
        duration: 1.2,
        delay: 3,
        src: cl.url('kesimpta_ate/3/3.svg'),
        type: 'mask',
        maskDirection: 'fromLeft'
      },
    ],
    mobile: [
      {
        direction: 'animated',
        duration: 1.2,
        delay: 0,
        src: cl.url('kesimpta_ate/3_mob/3_mob.svg'),
        type: 'mask',
        maskDirection: 'fromLeft'
      },
    ]
  },
  7: {
    desktop: [
      {
        direction: 'animated',
        duration: 1.2,
        delay: 0,
        src: cl.url('kesimpta_ate/2/0.svg'),
        type: 'mask',
        maskDirection: 'fromLeft'
      },
      {
        direction: 'animated',
        duration: 1.2,
        delay: 1,
        src: cl.url('kesimpta_ate/2/1.svg'),
        type: 'mask',
        maskDirection: 'fromLeft'
      },
      {
        direction: 'animated',
        duration: 1.2,
        delay: 2,
        src: cl.url('kesimpta_ate/2/2.svg'),
        type: 'fade',
      },
      {
        direction: 'animated',
        duration: 1.2,
        delay: 3,
        src: cl.url('kesimpta_ate/2/3.svg'),
        type: 'mask',
        maskDirection: 'fromLeft'
      },
    ],
    mobile: [
      {
        direction: 'animated',
        duration: 1.2,
        delay: 0,
        src: cl.url('kesimpta_ate/2_mob/2_mob.svg'),
        type: 'mask',
        maskDirection: 'fromLeft'
      },
    ]
  },
  8: {
    desktop: [
      {
        direction: 'animated',
        duration: 1.2,
        delay: 0,
        src: cl.url('kesimpta_ate/9/0.svg'),
        type: 'mask',
        maskDirection: 'fromLeft'
      },
      {
        direction: 'animated',
        duration: 1.2,
        delay: 1,
        src: cl.url('kesimpta_ate/9/1.svg'),
        type: 'mask',
        maskDirection: 'fromBottom'
      },
      {
        direction: 'animated',
        duration: 1.2,
        delay: 2,
        src: cl.url('kesimpta_ate/9/2.svg'),
        type: 'fade',
      },
    ],
    mobile: [
      {
        direction: 'animated',
        duration: 1.2,
        delay: 0,
        src: cl.url('kesimpta_ate/9_mob/9_mob.svg'),
        type: 'mask',
        maskDirection: 'fromLeft'
      },
    ]
  },
  9: {
    desktop: [
      {
        direction: 'animated',
        duration: 1.2,
        delay: 0,
        src: cl.url('kesimpta_ate/1/0.svg'),
        type: 'mask',
        maskDirection: 'fromLeft'
      },
      {
        direction: 'animated',
        duration: 1.2,
        delay: 1,
        src: cl.url('kesimpta_ate/1/1.svg'),
        type: 'mask',
        maskDirection: 'fromLeft'
      },
      {
        direction: 'animated',
        duration: 1.2,
        delay: 2,
        src: cl.url('kesimpta_ate/1/2.svg'),
        type: 'fade',
      },
      {
        direction: 'animated',
        duration: 1.2,
        delay: 3,
        src: cl.url('kesimpta_ate/1/3.svg'),
        type: 'mask',
        maskDirection: 'fromLeft'
      },
    ],
    mobile: [
      {
        direction: 'animated',
        duration: 1.2,
        delay: 0,
        src: cl.url('kesimpta_ate/1_mob/1_mob.svg'),
        type: 'mask',
        maskDirection: 'fromLeft'
      },
    ]
  },
  10: {
    desktop: [
      {
        direction: 'animated',
        duration: 1.2,
        delay: 0,
        src: cl.url('kesimpta_ate/10/0.svg'),
        type: 'mask',
        maskDirection: 'fromLeft'
      },
      {
        direction: 'animated',
        duration: 1.2,
        delay: 1,
        src: cl.url('kesimpta_ate/10/1.svg'),
        type: 'mask',
        maskDirection: 'fromLeft'
      },
      {
        direction: 'animated',
        duration: 1.2,
        delay: 2,
        src: cl.url('kesimpta_ate/10/2.svg'),
        type: 'fade',
      },
      {
        direction: 'animated',
        duration: 1.2,
        delay: 3,
        src: cl.url('kesimpta_ate/10/3.svg'),
        type: 'mask',
        maskDirection: 'fromLeft'
      },
    ],
    mobile: [
      {
        direction: 'animated',
        duration: 1.2,
        delay: 0,
        src: cl.url('kesimpta_ate/10_mob/10_mob.svg'),
        type: 'mask',
        maskDirection: 'fromLeft'
      },
    ]
  },
};

export default animationsData;
